/*
 *  Copyright 2019, 2020, 2021, 2022, 2023 LiteFarm.org
 *  This file is part of LiteFarm.
 *
 *  LiteFarm is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  LiteFarm is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 *  GNU General Public License for more details, see <https://www.gnu.org/licenses/>.
 */
export const CROP_PLAN_NAME = 'crop_plan_name';
export const PLAN_START_DATE = 'plan_start_date';
export const REPEAT_FREQUENCY = 'repeat_frequency';
export const REPEAT_INTERVAL = 'repeat_interval';
export const DAYS_OF_WEEK = 'days_of_week';
export const MONTH_REPEAT_ON = 'month_repeat_on';
export const FINISH = 'finish';
export const AFTER_OCCURRENCES = 'after_occurrences';
export const FINISH_ON_DATE = 'finish_on_date';
